import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Американски футбол",
    Baseball: "Бейзбол",
    Basketball: "Баскетбол",
    Boxing: "Бокс",
    Chess: "Шах",
    Cricket: "Крикет",
    Darts: "Дартс",
    Entertainment: "Забавление",
    "E-Sports": "Е-Спортове",
    Football: "Футбол",
    "Formula 1": "Формула 1",
    "Gaelic Football": "Галски Футбол",
    "Generic Sport": "Генеричен спорт",
    Golf: "Голф",
    "Greyhound Racing": "Кучешки надбягвания",
    Handball: "Хандбал",
    "Ice Hockey": "Хокей на лед",
    IndyCar: "Индикар",
    MMA: "ММА",
    Nascar: "Наскар",
    Politics: "Политика",
    "Rugby League": "Ръгби Лига",
    "Rugby Union": "Ръгби Юниън",
    Snooker: "Снукър",
    "Table Tennis": "Тенис на маса",
    Tennis: "Тенис",
    "Virtual Football": "Виртулен футбол",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} да спечели",
    WinFirstRound: "{name} да спечели първия рунд",
    FirstTouchdown: "{name} да отбележат първо тъчдаун",
    FirstTry: "{name} да отбележат първо Трай",
    TotalGoals: "{name} Брой голове",
    TotalRuns: "{name} Общо бягания",
    TotalPoints: "{name} Брой точки",
    TopBatsman: "{name} да бъде Топ Батсман",
    TopBowler: "{name} да бъде Топ Боулър",
    FirstScore: "{name} да отбележи първи"
  },
  PromoTexts: {
    Pick: "Направете своя избор",
    Bet: "заложете",
    Pays: "заплащане"
  },
  DateTimeTexts: {
    Today: "Днес",
    Tomorrow: "Утре",
    Live: "на Живо"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Направете своя избор",
    Return: "заплащане",
    Stake: "заложете",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Отбелязане голове",
    Shots: "Удари",
    "Shots on target": "Удари в очертанията",
    "Ball possession": "Владение на топката",
    "Goals conceded": "Допуснати голове",
    "Per match": "за мач",
    H2H: "TaT",
    W: "П",
    D: "Р",
    L: "З"
  }
};
